export const en = {
  "photos.panel.title": "Photos",
  "photos.panel.body":
    "Site photos, before/after shots or existing conditions. These print on the quote your client receives.",
  "photos.printsBadge": "Prints on the PDF",
  "photos.count": "{count} of {max}",
  "photos.drop.title": "Add job-site photos",
  "photos.drop.body": "Tap to choose from your camera roll, or drag files here.",
  "photos.drop.choose": "Choose photos",
  "photos.drop.camera": "Take a photo",
  "photos.drop.hint": "JPG or PNG · up to {max} photos · added photos can be reordered",
  "photos.full": "Photo limit reached. Remove one to add another.",
  "photos.position": "Photo {n}",
  "photos.caption.label": "Caption (optional)",
  "photos.caption.placeholder": "e.g. Existing 200A service — meter corroded",
  "photos.action.up": "Move earlier",
  "photos.action.down": "Move later",
  "photos.action.remove": "Remove photo",
  "photos.action.retry": "Retry",
  "photos.action.save": "Save to device",
  "photos.saveError": "Couldn't save this photo. Try again.",
  "photos.saveHint": "Tap the share icon on a photo to save a copy to your device.",
  "photos.removed": "Photo removed",
  "photos.addedSingular": "Adding photo…",
  "photos.addedPlural": "Adding {count} photos…",
  "photos.reordered": "Photo order updated",
  "photos.uploading": "Uploading…",
  "photos.converting": "Converting photo — this can take a while on some devices…",
  "photos.uploadError": "Upload failed. Check your connection and try again.",
  "photos.cameraError": "Couldn't open the camera. Check your camera permission and try again.",
  "photos.unsupportedFormat": "This photo's format isn't supported here. Save it as JPG or PNG, then try again.",
  "photos.resolveError": "Couldn't load one or more photos.",
  "photos.sheet.title": "Site Photos",
  "photos.sheet.noteSingular": "1 photo attached to this quote.",
  "photos.sheet.notePlural": "{count} photos attached to this quote.",
};

export const es = {
  "photos.panel.title": "Fotos",
  "photos.panel.body":
    "Fotos de obra, antes/después o condiciones existentes. Se imprimen en el presupuesto que recibe tu cliente.",
  "photos.printsBadge": "Se imprime en el PDF",
  "photos.count": "{count} de {max}",
  "photos.drop.title": "Agregar fotos de obra",
  "photos.drop.body": "Toca para elegir de tu galería o arrastra archivos aquí.",
  "photos.drop.choose": "Elegir fotos",
  "photos.drop.camera": "Tomar una foto",
  "photos.drop.hint": "JPG o PNG · hasta {max} fotos · se pueden reordenar",
  "photos.full": "Límite alcanzado. Quita una para agregar otra.",
  "photos.position": "Foto {n}",
  "photos.caption.label": "Leyenda (opcional)",
  "photos.caption.placeholder": "ej. Servicio existente de 200A — medidor corroído",
  "photos.action.up": "Mover antes",
  "photos.action.down": "Mover después",
  "photos.action.remove": "Quitar foto",
  "photos.action.retry": "Reintentar",
  "photos.action.save": "Guardar en el dispositivo",
  "photos.saveError": "No se pudo guardar esta foto. Intenta de nuevo.",
  "photos.saveHint": "Toca el ícono de compartir en una foto para guardar una copia en tu dispositivo.",
  "photos.removed": "Foto eliminada",
  "photos.addedSingular": "Subiendo foto…",
  "photos.addedPlural": "Subiendo {count} fotos…",
  "photos.reordered": "Orden de fotos actualizado",
  "photos.uploading": "Subiendo…",
  "photos.converting": "Convirtiendo foto — esto puede tardar un poco en algunos dispositivos…",
  "photos.uploadError": "Error al subir. Revisa tu conexión e intenta de nuevo.",
  "photos.cameraError": "No se pudo abrir la cámara. Revisa el permiso de cámara e intenta de nuevo.",
  "photos.unsupportedFormat": "El formato de esta foto no es compatible. Guárdala como JPG o PNG e intenta de nuevo.",
  "photos.resolveError": "No pudimos cargar una o más fotos.",
  "photos.sheet.title": "Fotos de obra",
  "photos.sheet.noteSingular": "1 foto adjunta a este presupuesto.",
  "photos.sheet.notePlural": "{count} fotos adjuntas a este presupuesto.",
};
